import { catchError, Observable, throwError } from 'rxjs';
import { isNotFound } from './is-not-found';
import { CatchErrorReturnType } from '@web/utils';

export const catchIfNotFound = <T, O>(
  fn: () => Observable<O>,
): CatchErrorReturnType<T, O> => {
  return catchError((response) => {
    if (isNotFound(response)) {
      return fn();
    }

    return throwError(() => response);
  });
};
